// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-wrapper {
  min-height: 500px;
  padding: 50px 0;
}
.news-wrapper .title-wrapper {
  font-weight: 700;
}
.news-wrapper .title-wrapper .title-h1 {
  margin-bottom: 0;
  font-size: 30.6px;
  font-weight: 700;
}
.news-wrapper .title-wrapper div {
  font-size: 16px;
  margin-bottom: 20px;
  color: #3A4597;
  font-family: Montserrat;
}
.news-wrapper .news-tag {
  font-size: 16px;
}
.common-section {
  padding: 90px 20px;
  margin: 0 auto;
  width: 1260px;
}
@media screen and (max-width: 767px) {
  .common-section.home-page-wrapper .home-page {
    padding: 56px 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/news/style.less"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,eAAA;AAAF;AAFA;EAKI,gBAAA;AAAJ;AALA;EAQM,gBAAA;EACA,iBAAA;EACA,gBAAA;AAAN;AAVA;EAcM,eAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;AADN;AAhBA;EAsBI,eAAA;AAHJ;AAOA;EAEE,kBAAA;EACA,cAAA;EACA,aAAA;AANF;AASA;EAGI;IAEI,kBAAA;EAVN;AACF","sourcesContent":["@title-text-color: #3A4597;\n.news-wrapper {\n  min-height: 500px;\n  padding: 50px 0;\n\n  .title-wrapper {\n    font-weight: 700;\n\n    .title-h1 {\n      margin-bottom: 0;\n      font-size: 30.6px;\n      font-weight: 700;\n    }\n\n    div {\n      font-size: 16px;\n      margin-bottom: 20px;\n      color: @title-text-color;\n      font-family: Montserrat;\n    }\n  }\n\n  .news-tag {\n    font-size: 16px;\n  }\n}\n\n.common-section {\n  // background: #f1f1f1;\n  padding: 90px 20px;\n  margin: 0 auto;\n  width: 1260px;\n}\n\n@media screen and (max-width: 767px) {\n  .common-section {\n    // min-height: 1540px;\n    &.home-page-wrapper {\n      .home-page {\n        padding: 56px 24px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
